import { normalizeKeywords } from '~/modules/retailMedia/helpers/keywords'

const fakeBudget: CommonSettings = {
  daily_budget: '0',
  cpc: '0',
  cpm: '0'
}

const formatProducts = (data: DTOPayloadMinCosts) =>
  data?.products?.map(item => ({
    id: item.id ? String(item.id) : undefined,
    sku: item.sku ? String(item.sku) : undefined,
    categories: item.categories || undefined
  })) || null

export const DTOPayloadMinCosts: IDTOMinCosts = {
  product: data => ({
    start_at: data.start_date,
    type: 'on_site',
    products: formatProducts(data),
    settings: {
      ...fakeBudget
    }
  }),
  digital_signage: data => ({
    start_at: data.start_date,
    type: 'in_store',
    settings: {
      ...fakeBudget
    }
  }),
  banner: data => ({
    start_at: data.start_date,
    type: 'on_site',
    banner: {
      keywords: normalizeKeywords(data.targeting?.keywords),
      categories: data.targeting?.categories?.split(',') || null,
      assets: data.banners.map(item => ({
        ad_size: item.ad_size,
        alt_text: item.alt_text,
        media_url: item.media_url
      }))
    },
    settings: {
      ...fakeBudget
    }
  }),
  banner_video: data => ({
    start_at: data.start_date,
    type: 'on_site',
    banner: {
      keywords: normalizeKeywords(data.targeting?.keywords),
      categories: data.targeting?.categories?.split(',') || null,
      assets: data.banners.map(item => ({
        ad_size: item.ad_size,
        alt_text: item.alt_text,
        media_url: item.media_url
      }))
    },
    settings: {
      ...fakeBudget
    }
  }),
  sponsored_brand: data => ({
    start_at: data.start_date,
    type: 'on_site',
    settings: {
      products: formatProducts(data),
      ...fakeBudget
    },
    brand_ad: {
      keywords: normalizeKeywords(data.targeting?.keywords),
      categories: data.targeting?.categories?.split(',') || null
    }
  }),
  sponsored_brand_video: data => ({
    start_at: data.start_date,
    type: 'on_site',
    settings: {
      products: formatProducts(data),
      ...fakeBudget
    },
    brand_ad: {
      keywords: normalizeKeywords(data.targeting?.keywords),
      categories: data.targeting?.categories?.split(',') || null
    }
  })
}
